

<div id="video-intro">
</div>

<div class="closeWrap" (click)="onBtnClick()">
  <div class="closeBtn" >跳过</div>
</div>


<!--<div id="wrapAll">-->
   <!--<div id="title" class="title fontSize21 lineHeight34">-->
      <!--英跃-->
   <!--</div>-->

   <!--<div id="subTitle" class="title fontSize16">-->
      <!--推荐学习路径-->
   <!--</div>-->
   <!--<div style="height: 9.8rem;overflow: hidden;">-->
   <!--<div id="wrap">-->
      <!--<img src="../../assets/picture/learningmap/icon1_new.png" alt="" id="image1">-->
      <!--<img src="../../assets/picture/learningmap/icon2.png" alt="" id="image2">-->
      <!--<img src="../../assets/picture/learningmap/icon3.png" alt="" id="image3">-->
      <!--<img src="../../assets/picture/learningmap/icon4.png" alt="" id="image4">-->
      <!--<img src="../../assets/picture/learningmap/icon5.png" alt="" id="image5">-->
      <!--<img src="../../assets/picture/learningmap/icon6.png" alt="" id="image6">-->

      <!--<div class="text fontSize16" id="text1">-->
         <!--<span>领导力DNA测验</span><br/>-->
      <!--</div>-->

      <!--<div class="text fontSize16" id="text2">-->
         <!--<span>能力诊断</span><br/>-->
      <!--</div>-->

      <!--<div class="text fontSize16" id="text3">-->
         <!--<span>课程学习</span><br/>-->
      <!--</div>-->

      <!--<div class="text fontSize16" id="text4">-->
         <!--<span>情景模拟</span><br/>-->
      <!--</div>-->

      <!--<div class="text fontSize16" id="text5">-->
         <!--<span>能力考核</span><br/>-->
      <!--</div>-->

      <!--<div class="text fontSize16" id="text6">-->
         <!--<span>毕业典礼</span><br/>-->
      <!--</div>-->
   <!--</div>-->
   <!--</div>-->
   <!--<div id="button" class="fontSize18" (click)="onBtnClick()">-->
      <!--进入学习地图-->
   <!--</div>-->
<!--</div>-->



// WEBPACK FOOTER //
// ./src/app/learning-map-introduction/learning-map-introduction.component.html